<template>
  <div class="d-flex flex-column pt-1">
    <p v-if="!singleline" class="mb-0 v-input v-label" :class="focused ? 'primary--text' : ''" style="font-size: 11px !important;">
      {{ label }}
    </p>
    <DatePicker v-model="boundValue" type="date" :format="format" class="QDateField3"
      :class="disabled ? 'removeunderline' : ''" :pickerOptions="pickerOptions" :default-time="'12:00:00'"
      :placeholder="placeholder || 'Select date'" :readonly="disabled" :prefix-icon="' '" :clearable="false" size="small"
      @focus="handleFocus(true)" @blur="handleFocus(false)" @change="$emit('change')">
    </DatePicker>
  </div>
</template>


<script>
import { DatePicker } from 'element-ui';

export default {
  name: 'QDateField3',
  props: {
    label: String,
    placeholder: String,
    value: [String, Date],
    disabled: Boolean,
    singleline: Boolean,
  },
  components: {
    DatePicker
  },

  data() {
    return {
      focused: false,

      pickerOptions: {
        firstDayOfWeek: 1,
      },
    };
  },

  methods: {
    handleFocus(e) {
      if (!this.disabled) {
        this.focused = e;
      }
    }
  },

  computed: {
    boundValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    format() {
      return this.$t('servicesystem.formatting.dateformat').replace('YYYY', 'yyyy').replace('DD', 'dd');
    }
  },

  watch: {},
};
</script>


<style lang='scss'>
.QDateField3 {
  width: unset !important;
}

.QDateField3 .el-input__inner {
  padding-left: 0px !important;
  padding-right: 0px !important;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0px;
}

.QDateField3 .el-input__inner:not(:focus){
  border-color: rgba(0, 0, 0, 0.42);
}
.QDateField3 .el-input__inner:focus {
  border-color: var(--v-primary-base)
}

.QDateField3.removeunderline .el-input__inner {
  border-bottom: none;
}

.el-time-panel {
  width: unset;
}
</style>